import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from './style';

const MenuHeaderTitle = (props) => {
  const { title, description = '' } = props;
  return (
    <div className="component_pageHeader_title">
      <div className="font-header3_medium black2 text-wrapper">
        {title || 'Page title'}
      </div>
      <div className="font-paragraph black2 text-wrapper">{description}</div>
    </div>
  );
};

const MenuHeaderBreadcrumb = (props) => {
  const { breadcrumb } = props;
  return (
    <div className="component_pageHeader_breadcrumb">
      <Breadcrumb>
        {breadcrumb.map((b, index) => {
          return (
            <Breadcrumb.Item key={b.label}>
              {b.to ? (
                <Link
                  to={b.to}
                  key={b.label}
                  className={`component_pageHeader_breadcrumb_link ${
                    index === breadcrumb.length - 1 ? 'last' : ''
                  }`}
                >
                  {b.label}
                </Link>
              ) : (
                <span
                  className={`black2 ${
                    index === breadcrumb.length - 1 ? 'last' : ''
                  }`}
                >
                  {b.label}
                </span>
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

const MenuHeaderComponent = (props) => {
  const { breadcrumb, description: desc, title } = props;

  return (
    <>
      {!breadcrumb && <MenuHeaderTitle title={title} description={desc} />}
      {breadcrumb && <MenuHeaderBreadcrumb breadcrumb={breadcrumb} />}
    </>
  );
};

export default MenuHeaderComponent;
